// extracted by mini-css-extract-plugin
export default {"Background":"Background_Background__4C8ox"};